import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditProfileDetailsComponent } from './edit-profile-details/edit-profile-details.component';
import { LoginService } from '../login/login.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DtoUser } from '../../models/user-center.model';
import { MatDialogCloseEvent } from '../../const';
import { ResetPasswordService } from '../reset-password/reset-password.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/services/shared.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {
  url: string = '';
  currentTheme: string = 'deesha';
  userData: DtoUser = {} as DtoUser;
  userId: string = '';
  uploadCompleted: boolean = false;
  selectedFileName: string = 'Click to upload';
  maxSize: number = 1 * 1024 * 1024; // 1 MB in bytes
  selectedFile: File | null = null;
  profileForm: FormGroup = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")
    ]),
    roleName: new FormControl('', [
      Validators.required,
      Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
    ]),
    clientAccountName: new FormControl('')
  });

  constructor(private dialog: MatDialog, private loginService: LoginService,
              private route: ActivatedRoute, private resetPasswordService: ResetPasswordService,
              private toasterService: ToastrService, private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    const auth = this.sharedService.getLoginToken();
    this.userId = auth.userId;
    this.getUserDetails();
    this.currentTheme = this.sharedService.getThemePreference()
  }

  
  saveThemePreference(themeName: string) {
    this.sharedService.setThemePreference(themeName);
    this.currentTheme = this.sharedService.getThemePreference();
  }

  getUserDetails(){
    
    this.loginService.getUserDetails(this.userId)
    .subscribe(
      {
        next: response=>{
          this.userData = response;
          this.profileForm.patchValue(this.userData);
          this.profileForm.controls['name'].setValue(this.userData.firstName + ' ' + this.userData.lastName);
          
          this.loginService.getDocumentApi(this.userData.profileUrl!)
            .subscribe({
              next: blob =>{
                  this.url = URL.createObjectURL(blob);
              },
              error: err =>{
                  this.url = '';
              }
            });
        }
      })
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.size <= this.maxSize) {
        this.selectedFile = file;
        this.selectedFileName = file.name;
        this.uploadProfile();
      } else {
        this.toasterService.warning('File size must be less than 1 MB.');
        this.selectedFile = null;
        this.selectedFileName = 'Click to upload';
      }
    } else {
      this.selectedFile = null;
      this.selectedFileName = 'Click to upload';
    }
  }

  uploadProfile(){
    const formData = new FormData();
    if (this.selectedFile) {
      formData.append('File', this.selectedFile, this.selectedFile.name);
    }
    this.resetPasswordService.uploadProfile(formData, parseInt(this.userId)).subscribe({
      next: (response) => {
        this.toasterService.success('Profile picture uploaded successfully!', 'Success');
        this.sharedService.profileUpdateCheck(true);
        this.getUserDetails();
      },
      error: (error) => {
        this.toasterService.error(error, 'Error')
      }
    });
  } 

  editProfileModal() {
    this.userData.userId = parseInt(this.userId);
    this.dialog.open(EditProfileDetailsComponent, 
      {
        width: '1000px',
        data: this.userData
      }).afterClosed().subscribe((popupEvent: any)=>{
        if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
          this.getUserDetails();
        }
      });
    }
}
